<template>
  <div class="guide">
    <Normaltop :url="url" title="报考指南" en="Application Guide"></Normaltop>
    <div class="guide-cont">
      <div class="part" ref="block0">
        <h2 class="part-title text-center">报考须知</h2>
        <el-row :gutter="40">
          <el-col :span="7">
            <h3 class="part-h3">报考条件：</h3>
            <p class="part-cont">
              1.考生需满18周岁；
              <br />2.报考者必须拥有中专以上学历；
              <br />3.考生应可以熟练的使用普通话；
            </p>
          </el-col>
          <el-col :span="9">
            <h3 class="part-h3">适合报考人群：</h3>
            <p class="part-cont">
              1.想掌握来访者常见问题的解决方案和思路，金融、保险行业从业者员；
              <br />2.想成为生涯规划咨询师的人士； <br />3.企业中高层管理者;
              <br />4.HR、猎头从业人员;
              <br />5.地产、保险、理财等高客单价行业顾问
              <br />6.心理咨询师等定制化咨询服务行业从业人员
              <br />7.高校老师、就业辅导导师、高校导员;
              <br />8.中学授课老师、中学班主任;
              <br />9.留学、营地教育、背景提升、学业规划、高考志愿规划师等学生教育领域的老师、班主任、负责人等;
            </p>
          </el-col>

          <el-col :span="8">
            <h3 class="part-h3">学习及报考费用:</h3>
            <p class="part-cont">
              1.费用含在线课程教学、考试、证书、配套软件平台VIP账户、线下辅导等，总计
              {{ this.$price }};
              <br />2.费用为一次性付费，付费完成后不可退款，可申请开具正规发票;
              <br />3. 付费完成后学员可获得无限次课程学习机会。
            </p>
          </el-col>
        </el-row>
        <h3 class="part-h3">报考方式：</h3>
        <div v-for="item in methods" :key="item.name">
          <div class="flex-col-center methods">
            <img class="icon" :src="item.url" alt srcset />
            <div>
              <h3 class="method-name">{{ item.name }}</h3>
              <p class="part-cont" v-html="item.cont"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Normaltop from '../components/normaltop'
  export default {
    name: 'Guide',
    components: { Normaltop },
    data() {
      return {
        url: require('../assets/image/guide/banner.png'),
        methods: [
          {
            name: '在线报名',
            url: require('../assets/image/guide/icon1.png'),
            cont:
              '1. 考生报名需在线注册并前往个人中心完善本人真实资料（请如实填写真实信息，以免影响证书生成及发放！）；<br/> 2.考生在缴费并完成线上或线下课程后即可在正式评测开放时间内进行考试，考试时间请留意公告。',
          },
          {
            name: '在线评测',
            url: require('../assets/image/guide/icon2.png'),

            cont: `
         1.考试采用在线答题闭卷形式，试题类型分为两种种类型（单选题、多选题），总计50道题目，请考生认真审题；<br/> 2.考试时长为两个小时，答题过程中不得以任何方式向第三方求助，且不可中途离场。
          `,
          },
          {
            name: '获得证书、颁证条件',
            url: require('../assets/image/guide/icon4.png'),
            cont: `
          1.生涯规划师测评考试总分为100分，80分以上即为通过此次考试并获得生涯规划师证书；<br/>
          2.考生在评测完成后请耐心等待，考试成绩在个人中心可以查询，电子证书每月月末签发；<br/>
          3.纸质证书会在制作完成后根据考生填写的地址快递发出，请学员注意短信通知，及时查看物流信息。
            `,
          },
          {
            name: '补考规则',
            url: require('../assets/image/guide/icon3.png'),
            cont: `
          1.报考者拥有一次补考机会，在评测结果出来后，不达标的需要在后续的考试开放时间内重新考试；<br/>
          2.补考请在一个月内完成，过期平台将清除补考机会！
            `,
          },
        ],
      }
    },
    created() { },
    methods: {},
  }
</script>
<style lang="less" scoped>
  .guide {
    font-size: 14px;

    .guide-cont {
      width: 70%;
      min-width: 1200px;
      margin: 0 auto;
      position: relative;
      box-sizing: border-box;
      padding: 70px 0;

      .part {
        width: 60%;
        min-width: 1100px;
        margin: 0 auto;
        position: relative;
        padding-top: 50px;

        .methods {
          padding: 25px 0;
        }

        .part-title {
          color: #000005;
          font-weight: bold;
          font-size: 36px;
          padding-bottom: 50px;
        }

        .method-name {
          color: #fd4a29;
          padding-top: 10px;
        }

        .part-h3 {
          font-size: 22px;
          padding-top: 20px;
        }

        .part-cont {
          padding-top: 16px;
          color: #666;
          line-height: 2;
        }

        .icon {
          width: 120px;
          // height: 120px;
          margin-right: 30px;
        }
      }
    }
  }
</style>